(function(){
    'use strict';

    angular
        .module('elogbooks.admin.settings')
        .controller('AdminAbsenceEditSettingsController', AdminAbsenceEditSettingsController);

    function AdminAbsenceEditSettingsController(
        $controller,
        $state,
        messenger,
        moment,
        lodash,
        apiClient,
        settingsCollection,
        recurrenceRulesService,
        elbSettings,
        module,
        fileTypeService
    ) {
        const vm = this;
        const base = $controller('AdminEditSettingsController', {
            $state: $state,
            messenger: messenger,
            moment: moment,
            lodash: lodash,
            apiClient: apiClient,
            settingsCollection: settingsCollection,
            settingsFields: [
                'default_yearly_entitlement',
                'default_holiday_year_start_day',
                'default_holiday_year_start_month'
            ],
            elbSettings: elbSettings,
            module: module,
            fileTypeService: fileTypeService,
            buildTabSettingFormTypes: () => ({
                'default_yearly_entitlement': { type: 'decimal', min: 0, max: 100, step: 0.5, notRequired: true },
                'default_holiday_year_start_day': { type: 'number', min: 1, max: 31, notRequired: true, options: { invalid: false } },
                'default_holiday_year_start_month': {
                    type: 'select',
                    options: recurrenceRulesService.ruleMonthOptions,
                    notRequired: true
                }
            }),
            validateTabSettings: null
        });
        angular.extend(vm, base);
    }
})();
